/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentCategory =
    (typeof DocumentCategory)[keyof typeof DocumentCategory];

export const DocumentCategory = {
    Other: 0,
    Asbestos: 1,
    EmergencyResponsePack: 2,
    Evacuation: 3,
    FireSafetyCompliance: 4,
    FireStrategy: 5,
    HealthSafetyFiles: 6,
    IncidentRiskReporting: 7,
    PestControl: 8,
    RiskAssessments: 9,
    SpecificationsHealthSafetyAndCompliance: 10,
    TrainingCompetenceHealthSafetyAndCompliance: 11,
    BuildingApprovals: 12,
    ContractsConstructionAndDevelopment: 13,
    InspectionsReportsSurveysConstructionAndDevelopment: 14,
    Planning: 15,
    PracticalCompletionDefects: 16,
    ProductMaterialInformation: 17,
    ProjectInformation: 18,
    SpecificationsConstructionAndDevelopment: 19,
    Warranties: 20,
    CommunicationSystems: 21,
    ContractsBuildingOperationsAndFacilities: 22,
    ElectricalSystems: 23,
    Financial: 24,
    FireDoors: 25,
    GasSystems: 26,
    GreaseTrap: 27,
    EmbeddedNetworks: 28,
    InspectionsReportsSurveysBuildingOperationsAndFacilities: 29,
    LifeSafetySystems: 30,
    LiftsElevators: 31,
    OMManual: 32,
    OtherBuildingAssets: 33,
    Permits: 34,
    PoliciesProceduresStrategies: 35,
    PressureSystems: 36,
    SecuritySystems: 37,
    Staffing: 38,
    SuppliersInformation: 39,
    TrainingCompetenceBuildingOperationsAndFacilities: 40,
    Utilities: 41,
    VentilationSystems: 42,
    WaterSystems: 43,
    Architectural: 44,
    CivilStructural: 45,
    Mechanical: 46,
    Electrical: 47,
    FireLifeSafety: 48,
    Hydraulic: 49,
    Landscape: 50,
    FacadeCladding: 51,
    ComplianceCertificates: 52,
    GroundGeotechnical: 53,
    InspectionsReportsSurveysEnvironmentalAndSite: 54,
    LicencesNotices: 55,
    Waste: 56,
    EasementsRightOfWay: 57,
    HeadLease: 58,
    Licences: 59,
    Marketing: 60,
    PartyWall: 61,
    RentOutgoings: 62,
    ResidentTenantEngagement: 63,
    TenanciesUnits: 64,
    Title: 65,
    Transactions: 66,
    InsuranceClaimsDisputes: 67,
    InsurancePoliciesCertificates: 68,
    Tax: 69,
    Valuations: 70,
} as const;
